import React, { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { primaryColor } from "assets/jss/material-dashboard-pro-react";
import Button from "components/CustomButtons/Button";
import HTMLEditor from "components/HTMLEditor/HTMLEditor";
import styles from "../ReportStyles.module.css";
import { updateReportBody } from "../reportUtils";

const PublicDisclosure = ({ data, report, setReportBody }) => {
  const [valueContent, setValueContent] = useState(data.description ?? "");

  const handleChangeDescription = (content) => {
    setValueContent(content);
    updateReportBody(
      setReportBody,
      "BACKGROUNDINFORMATION",
      "PublicDisclosure",
      "description",
      content
    );
  };

  return (
    <>
      <h3>Background Information: Public Disclosure</h3>

      <p className={styles.reportParagraphTitle}>
        The following is information on the places where the Program Education
        Objectives (PEOs), Student Outcomes (SOs), annual student enrollment,
        and graduation data specific to the program is posted or made accessible
        to the public: {data.publicDisclosure}
      </p>
      <HTMLEditor
        valueContent={valueContent}
        setValueContent={handleChangeDescription}
      />
    </>
  );
};

export default PublicDisclosure;
